module.exports = __webpack_public_path__ + "static/sydney-480x480-0bfb45cd95194369d4a17e361290c1cd.webp";